import { PrimaryButton, Stack, TextField } from "@fluentui/react"
import { useState } from "react"
import { makeApiCall } from "../services/apiService"
import { getUrlParameter } from "../services/helperService"

export function MemberVerify() {
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState<string | null>(null)
	const [isVerified, setIsVerified] = useState(false)

	const employerId = getUrlParameter("employerId")

	const [form, setForm] = useState({
		firstName: "",
		lastName: "",
		dob: "",
		email: ""
	})

	const handleChange = (field: string, value: any) => setForm(f => ({ ...f, [field]: value }))

	const handleVerify = async () => {
		setLoading(true)
		setError(null)

		const body = {
			firstName: form.firstName,
			lastName: form.lastName,
			dob: form.dob,
			email: form.email,
			employerId: employerId
		}

		try {
			await makeApiCall("handleMemberVerification", "POST", JSON.stringify(body))
			setIsVerified(true)
		} catch (e: any) {
			setError(e.message || "Error verifying member")
		} finally {
			setLoading(false)
		}
	}

	if (isVerified) {
		return (
			<div className="success-container">
				<h3>Identity Verified!</h3>
				<p>
					We've found your record and sent a portal invitation to <strong>{form.email}</strong>.
				</p>
				<p>Please check your inbox (and spam folder) and click the link in the email to complete your registration.</p>
				<button onClick={() => (window.location.href = "/")}>Return Home</button>
			</div>
		)
	}

	return (
		<Stack tokens={{ childrenGap: 15 }} style={{ maxWidth: 400, margin: "20px auto" }}>
			<Stack>
				<h3>Member Verification</h3>
				<p>Please enter your details to find your record.</p>
			</Stack>

			<TextField label="First Name" required value={form.firstName} onChange={(_, newValue) => handleChange("firstName", newValue || "")} />

			<TextField label="Last Name" required value={form.lastName} onChange={(_, newValue) => handleChange("lastName", newValue || "")} />

			<TextField label="Date of Birth" type="date" required value={form.dob} onChange={(_, newValue) => handleChange("dob", newValue || "")} />

			<TextField label="Email Address" required placeholder="The email you want to use for login" value={form.email} onChange={(_, newValue) => handleChange("email", newValue || "")} />

			{error && <span style={{ color: "red", fontSize: "12px" }}>{error}</span>}

			<Stack horizontal styles={{ root: { marginTop: 10 } }}>
				<PrimaryButton text={loading ? "Verifying..." : "Verify & Create Account"} onClick={handleVerify} disabled={loading} />
			</Stack>
		</Stack>
	)
}
